import Phaser from 'phaser';
import { knock } from './effects';

class Eye extends Phaser.GameObjects.Sprite {
  constructor(scene, x, y) {
    super(scene, x, y, 'door_two_eye');
    
    this.setAlpha(0);
    this.setOrigin(0.5, 1);

    this.scene.add.existing(this);

    this.scene.tweens.add({
      targets: this,
      alpha: 1,
      duration: 500,
    });

    this.scene.time.delayedCall(1500, () => {
      this.blink();
    });

    this.scene.time.delayedCall(3000, () => {
      this.blink();
    });

    this.scene.time.delayedCall(4500, () => {
      this.scene.tweens.add({
        targets: this,
        alpha: 0,
        duration: 500,
      });
    });
  }

  blink() {
    this.scene.tweens.add({
      targets: this,
      duration: 150,
      alpha: 1,
      onStart: () => {
        this.setTexture('door_two_eye_closed');
      },
      onComplete: () => {
        this.setTexture('door_two_eye');
      },
    });
  }
}

export default class DoorTwo extends Phaser.GameObjects.Sprite {
  constructor(scene, x, y) {
    super(scene, x, y, 'door');

    this.setOrigin(0.5, 1);
    this.setScale(0.8);

    this.emitters = [];

    this.scene.add.existing(this);
  }

  open() {
    this.rectangle = this.scene.add.rectangle(
      this.x,
      this.y - 300,
      400,
      400,
      '#0C0E1D'
    );
    const shape = this.scene.add
      .image(this.x - 2, this.y - 278, 'door_two_window_closed')
      .setOrigin(0.5, 1)
      .setScale(0.85)
      .setVisible(false);
    this.rectangle.mask = new Phaser.Display.Masks.BitmapMask(
      this.scene,
      shape
    );

    this.eye = new Eye(this.scene, this.x, this.y - 290);

    this.scene.time.delayedCall(6000, () => {
      this.candies();
      this.scene.audio.avalanche.play();
    });
  }

  candies() {
    const candy1 = this.scene.add.particles('candy1');
    const candy2 = this.scene.add.particles('candy2');
    const candy3 = this.scene.add.particles('candy3');
    const candy4 = this.scene.add.particles('candy4');
    const candy5 = this.scene.add.particles('candy5');
    const candy6 = this.scene.add.particles('candy6');
    const candy7 = this.scene.add.particles('candy7');

    const groundRectangle = new Phaser.Geom.Rectangle(this.x - 5000, this.y, 6000, 1);

    [candy1, candy2, candy3, candy4, candy5, candy6].forEach((particles, index) => {
      this.emitters.push(
        particles.createEmitter({
          x: this.x,
          y: this.y - 290,
          delay: index * 20,
          speed: { min: 350, max: 550 },
          angle: { min: -230, max: -190 },
          gravityY: 100,
          scale: 0.3,
          quantity: 1,
          frequency: 200,
          rotate: { start: 0, end: 450, ease: 'Back.easeOut' },
          // blendMode: 'ADD', // 'SCREEN'
          bounds: groundRectangle,
          bounce: 0.4,
          collideLeft: false,
          collideLeft: false,
          collideTop: false,
          collideBottom: true,
          lifespan: 4000,
        })
      );
    });

    this.scene.time.delayedCall(1000, () => {
      this.scene.player.stickCandies();
    });

    this.scene.time.delayedCall(2000, () => {
      this.emitters.forEach(emitter => {
        emitter.stop();
      });
    });
  }

  knock() {
    knock.call(this.scene);
  }

  close() {
    this.rectangle.setVisible(false);
    this.eye.setVisible(false);
  }

  preUpdate() {
    this.emitters.forEach(emitter => {

    });
  }
}

export function preload() {
  // Eye
  this.load.image('door_two_eye', 'ornaments/door-two/door_0000_open_eye.png');
  this.load.image(
    'door_two_eye_closed',
    'ornaments/door-two/door_0001_closed_eye.png'
  );
  // Closed window
  this.load.image(
    'door_two_window_closed',
    'ornaments/door-two/door_0002_opened_window.png'
  );
  // Candies
  Array(6).fill(null).forEach((a, index) => {
    this.load.image(`candy${index + 1}`, `ornaments/candy${index + 1}.png`);
  });
}
